import { PRINTER_TYPE, PRINTER_DRIVER_TYPE } from "@dpdgroupuk/mydpd-enums";
import ServiceThermalDriver from "./ServiceThermalDriver";
import UsbWebDeviceThermalDriver from "./UsbWebDeviceThermalDriver";
import BrowserHtmlDriver from "./BrowserHtmlDriver";
import { EventEmitter } from "../../utils";
import PrinterError from "./PrinterError";

class Printer extends EventEmitter {
  static isLaserPrinter(printerType) {
    return printerType === PRINTER_TYPE.LASER;
  }

  static isThermalPrinter(printerType) {
    return printerType !== PRINTER_TYPE.LASER;
  }

  constructor(localApis) {
    super();
    this.localApis = localApis;
    this.config = {
      printToThermal: false,
      // by default, try to use browser driver to print html
      thermalPrinterDriverType: PRINTER_DRIVER_TYPE.NONE
    };
    this._configureError = null;
    this.html = new BrowserHtmlDriver(this);
  }
  /**
   * Use that method on page load or when dynamically change printer settings to configure driver to print labels
   * @param config
   * @returns {Promise<void>}
   */


  async configure(config) {
    this.config = { ...this.config,
      ...config
    };
    const {
      thermalPrinterDriverType,
      printToThermal
    } = this.config;

    if (printToThermal) {
      if (thermalPrinterDriverType === PRINTER_DRIVER_TYPE.MYDPD_SERVICE) {
        this.driver = new ServiceThermalDriver(this);
      } else if (thermalPrinterDriverType === PRINTER_DRIVER_TYPE.WEB_USB) {
        this.driver = new UsbWebDeviceThermalDriver(this);
      } else {
        this.driver = new BrowserHtmlDriver(this);
      }
    } else {
      this.driver = new BrowserHtmlDriver(this);
    }

    try {
      await this.driver.configure(); // reset error if called on refresh

      this._configureError = null;
      this.emit("printer-ready", this.config);
    } catch (err) {
      this._configureError = err;
      this.emit("printer-fail", {
        config: this.config,
        error: err
      });
    }
  }

  getPrinterConfig() {
    return this.config;
  } // invoice should be printed always as html


  printHtml(labelsArray) {
    return this.html.print(labelsArray.join(""));
  }
  /**
   *
   * @param labelsArray
   * @returns {Promise<void|*|(function(*, *): Promise<void|*>)|void>}
   */


  async printLabels(labelsArray) {
    if (this._configureError) {
      throw new PrinterError(`To proceed, correct the following issue: ${this._configureError.message}`, PrinterError.STATUS_CODE.FAILED_TO_PRINT);
    }

    return Promise.resolve().then(() => {
      const labels = labelsArray.join("");
      return this.driver.print(labels);
    }).then(r => {
      this.emit("printer-print-success", r);
      return r;
    }).catch(err => {
      this.emit("printer-print-fail", err);
      throw err;
    });
  }

}

export default Printer;